<template>
    <div>
        <!-- begin:Desktop -->
        <div class="d-flex align-items-center flex-wrap gap-2 w-100 none-mobile">
            <div class="d-flex align-items-center flex-wrap row-gap-1">
                <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                    :disabled="currentPageComputed < 2"
                    @click.stop="currentPageComputed = 1"
                    :aria-label="$tl('labels.pager.firstPage')"
                    v-tooltip="getTooltip($tl('labels.pager.firstPage'))">
                    <feather type="skip-back" />
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                    :disabled="currentPageComputed < 2"
                    @click.stop="--currentPageComputed"
                    :aria-label="$tl('labels.pager.previousPage')"
                    v-tooltip="getTooltip($tl('labels.pager.previousPage'))">
                    <feather type="chevron-left" />
                </button>

                <button
                    v-if="startPageNumbersRange > 1"
                    type="button"
                    class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                    @click="currentPageComputed = startPageNumbersRange - 1"
                    :aria-label="$tl('labels.pager.previous')"
                    v-tooltip="getTooltip($tl('labels.pager.previous'))">
                    <feather type="more-horizontal" />
                </button>

                <button
                    v-for="numPage in pageNumbersRange"
                    :key="numPage"
                    type="button"
                    class="btn btn-sm rounded-pill py-1 px-2 mx-1"
                    :class="{ 'btn-success': currentPageComputed === numPage }"
                    :aria-current="currentPageComputed === numPage ? 'page' : undefined"
                    @click.stop="currentPageComputed = numPage">
                    {{ numPage }}
                </button>

                <button
                    v-if="endPageNumbersRange < nbPages"
                    type="button"
                    class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                    @click="currentPageComputed = endPageNumbersRange"
                    :aria-label="$tl('labels.pager.next')"
                    v-tooltip="getTooltip($tl('labels.pager.next'))">
                    <feather type="more-horizontal" />
                </button>

                <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                    :disabled="currentPageComputed > nbPages - 1"
                    @click.stop="++currentPageComputed"
                    :aria-label="$tl('labels.pager.nextPage')"
                    v-tooltip="getTooltip($tl('labels.pager.nextPage'))">
                    <feather type="chevron-right" />
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                    :disabled="currentPageComputed > nbPages - 1"
                    @click.stop="currentPageComputed = nbPages"
                    :aria-label="$tl('labels.pager.lastPage')"
                    v-tooltip="getTooltip($tl('labels.pager.lastPage'))">
                    <feather type="skip-forward" />
                </button>
            </div>

            <div class="d-flex align-items-center">
                <select
                    class="form-select w-auto me-2"
                    v-model="nbResultsPerPageComputed"
                    :aria-label="$tl('labels.pager.nbResultsPerPage')">
                    <option v-for="nbResult in availableNbResultsPerPage" :key="nbResult.value" :value="nbResult.value">
                        {{ nbResult.label }}
                    </option>
                </select>
                <p class="my-auto text-nowrap">{{ $tl("labels.pager.nbResultsPerPage") }}</p>
            </div>

            <p class="my-auto ms-auto">
                {{ $t("labels.pager.currentPageInfo", { currentPage: currentPageComputed, nbPages }) }}
                {{ $t("labels.pager.nbResults", { nbResults }) }}
            </p>
        </div>
        <!-- end:Desktop -->

        <!-- begin:Mobile -->
        <div class="d-flex align-items-center w-100 none-desk">
            <button
                type="button"
                class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                :disabled="currentPageComputed < 2"
                @click="currentPageComputed = 1"
                :aria-label="$tl('labels.pager.firstPage')"
                v-tooltip="getTooltip($tl('labels.pager.firstPage'))">
                <feather type="skip-back" />
            </button>
            <button
                type="button"
                class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                :disabled="currentPageComputed < 2"
                @click="--currentPageComputed"
                :aria-label="$tl('labels.pager.previousPage')"
                v-tooltip="getTooltip($tl('labels.pager.previousPage'))">
                <feather type="chevron-left" />
            </button>

            <div>
                <p class="my-auto mx-2">
                    {{ $t("labels.pager.currentPageInfo", { currentPage: currentPageComputed, nbPages }) }}
                </p>
            </div>

            <button
                type="button"
                class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                :disabled="currentPageComputed > nbPages - 1"
                @click="++currentPageComputed"
                :aria-label="$tl('labels.pager.nextPage')"
                v-tooltip="getTooltip($tl('labels.pager.nextPage'))">
                <feather type="chevron-right" />
            </button>
            <button
                type="button"
                class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-1 me-1"
                :disabled="currentPageComputed > nbPages - 1"
                @click="currentPageComputed = nbPages"
                :aria-label="$tl('labels.pager.lastPage')"
                v-tooltip="getTooltip($tl('labels.pager.lastPage'))">
                <feather type="skip-forward" />
            </button>
        </div>
        <!-- end:Mobile -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            additionalNbResultsPerPage: [],
        };
    },
    props: {
        nbPages: {
            type: Number,
            required: true,
        },
        nbResults: {
            type: Number,
            required: true,
        },
        nbResultsPerPage: {
            type: [Number, String],
            default: 12,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        nbNumPages: {
            type: Number,
            default: 10,
        },
        pageSizeOptions: {
            type: Array,
            default: null,
        },
        includeAll: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        nbResultsPerPageComputed: {
            get() {
                return this.nbResultsPerPage;
            },
            set(value) {
                this.$emit("set-nb-results-per-page", value);
                this.currentPageComputed = 1;
            },
        },
        currentPageComputed: {
            get() {
                return this.currentPage;
            },
            set(value) {
                this.$emit("set-current-page", value);
            },
        },
        availableNbResultsPerPage() {
            let values = Array.isArray(this.pageSizeOptions) && this.pageSizeOptions.length > 0 ? this.pageSizeOptions.slice() : [5, 10, 12, 20];

            values = values.concat(this.additionalNbResultsPerPage);

            if (this.nbResultsPerPage !== "all" && !values.includes(this.nbResultsPerPage)) {
                this.additionalNbResultsPerPage.push(this.nbResultsPerPage);
            }

            values.sort((a, b) => a - b);

            const options = values.map((value) => {
                return { value, label: value };
            });

            if (this.includeAll) {
                options.unshift({
                    value: "all",
                    label: "Tout",
                });
            }

            return options;
        },
        startPageNumbersRange() {
            const getStartRange = (multiplier = 1) => {
                if (this.currentPageComputed > this.nbNumPages * multiplier) {
                    return getStartRange(multiplier + 1);
                }

                return (multiplier - 1) * this.nbNumPages + 1;
            };

            return getStartRange();
        },
        endPageNumbersRange() {
            return this.startPageNumbersRange + this.nbNumPages > this.nbPages + 1 ? this.nbPages + 1 : this.startPageNumbersRange + this.nbNumPages;
        },
        pageNumbersRange() {
            return _.range(this.startPageNumbersRange, this.endPageNumbersRange);
        },
    },
};
</script>
